import { render, staticRenderFns } from "./Sys_Role.vue?vue&type=template&id=e4f46970&"
import script from "./Sys_Role.vue?vue&type=script&lang=js&"
export * from "./Sys_Role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports